import { createSelector } from "reselect";

const selectConfigs = (state) => state.apps;

const selectApps = () => createSelector(selectConfigs, (appsState) => appsState?.apps);

const selectAppsLoading = () => createSelector(selectConfigs, (appsState) => appsState?.loading);

const selectAppsMarkets = () =>
  createSelector(selectConfigs, (appsState) => appsState?.appsMarkets);

const selectAppsError = () => createSelector(selectConfigs, (appsState) => appsState?.error);

const selectSelectedAppLocalizations = () =>
  createSelector(selectConfigs, (appsState) => appsState?.selectedApp?.localizations);

const selectOriginalDefaultLocale = () =>
  createSelector(selectConfigs, (appsState) => appsState?.originalDefaultLocalization);

const selectEditingLocale = () =>
  createSelector(selectConfigs, (appsState) => appsState?.editingLocalization);

const selectIsRolesReassigned = () =>
  createSelector(selectConfigs, (appsState) => appsState?.isRolesReassigned);

const selectSelectedApp = () =>
  createSelector(selectConfigs, (appsState) => appsState?.selectedApp);

export {
  selectApps,
  selectAppsMarkets,
  selectAppsError,
  selectSelectedAppLocalizations,
  selectEditingLocale,
  selectOriginalDefaultLocale,
  selectAppsLoading,
  selectIsRolesReassigned,
  selectSelectedApp
};
